import api from '../config/axiosConfig';
import { API_BASE_URL } from '../utils/constants';

export interface ActivityLog {
  id: number;
  user_id?: number;
  branch_id?: number;
  activity_type: string;
  action: string;
  resource_type?: string;
  resource_id?: number;
  metadata?: Record<string, any>;
  ip_address?: string;
  user_agent?: string;
  success: boolean;
  error_message?: string;
  created_at: string;
  user?: {
    id: number;
    username: string;
    full_name: string;
    role: string;
  };
  branch?: {
    id: number;
    code: string;
    name: string;
  };
}

export interface ActivitySummary {
  total_activities: number;
  failed_activities: number;
  suspicious_activities: number;
  unique_users: number;
  most_active_user?: {
    id: number;
    username: string;
    full_name: string;
  };
  most_active_count: number;
  period_days: number;
}

export interface ActivityLogParams {
  user_id?: number;
  branch_id?: number;
  activity_type?: string;
  start_date?: string;
  end_date?: string;
  search?: string;
  page?: number;
  page_size?: number;
}

const API_URL = `${API_BASE_URL}/activity-logs`;

export const getActivityLogs = async (params?: ActivityLogParams): Promise<ActivityLog[]> => {
  const response = await api.get<ActivityLog[]>(API_URL, { params });
  return response.data;
};

export const getSuspiciousActivities = async (days: number = 7): Promise<ActivityLog[]> => {
  const response = await api.get<ActivityLog[]>(`${API_URL}/suspicious`, {
    params: { days }
  });
  return response.data;
};

export const getActivitySummary = async (days: number = 7): Promise<ActivitySummary> => {
  const response = await api.get<ActivitySummary>(`${API_URL}/summary`, {
    params: { days }
  });
  return response.data;
};

export const getUserActivities = async (userId: number, days: number = 30): Promise<ActivityLog[]> => {
  const response = await api.get<ActivityLog[]>(`${API_URL}/user/${userId}`, {
    params: { days }
  });
  return response.data;
};
